// Connect: the two new Command Center views (Connect, Classic CGS) and the Contacts tab.
//
// ── Feature flag ────────────────────────────────────────────────────────────────────────
// Default OFF, the same pattern as Insights (helpers/insights/insightPages.js). On per build with
// VUE_APP_CONNECT=1, or per browser for testing without a rebuild:
//     localStorage.setItem("connect.enabled", "1")   // on
//     localStorage.setItem("connect.enabled", "0")   // forced off, even when the build turns it on
// When it's off nothing changes: the dashboard drop-down keeps Originate / Process / Underwrite,
// the sidebar has no Contacts item, and /contacts routes send you to the Command Center.
//
// ── Where the data comes from (no new API) ──────────────────────────────────────────────
// Everything is an existing GSWebAPIv2 endpoint that already accepts this app's CGS2022AzureAD
// token:
//   Contacts tab, Connect board   api/GSDesignContacts/*   the GSDesign (CGS 3.0) facade over the
//                                 same CGS contacts CGS2022 shows. The caller comes from the token,
//                                 every contact is access-checked, and SSNs are never returned.
//   Classic CGS figures, chart    api/Insights/GetInsightsData, GetInsightsChartMTDOverlayData,
//                                 with the bodies CGS2022's dashboard cards send.
//   Tasks                         api/CGSTask/GetTasks (CGS2022 tasksCard.vue).
//   Birthdays                     api/Birthdays/GetImminentBirthdays, AcknowledgeBirthday
//                                 (CGS2022 birthdayCard.vue).
//
// ── Not marketing ───────────────────────────────────────────────────────────────────────
// The Contacts tab deliberately leaves out everything GSDesign has for marketing: campaigns,
// bulk actions, bulk and one-to-one text/email, scheduled or picture texts. It reads contacts,
// shows their history and loans, and writes only notes, tasks and status changes.
//
// ── "View as" ───────────────────────────────────────────────────────────────────────────
// The GSDesignContacts endpoints take the caller from the bearer token. swiftApp's impersonation
// (localStorage azure_id) is not sent to them, so while impersonating, the Contacts tab and the
// Connect board show the signed-in user's own contacts. The CGS endpoints (Insights, tasks,
// birthdays) take azureId as before, so they follow impersonation like the rest of the app.

export const CONNECT_FLAG_KEY = 'connect.enabled'

export function isConnectEnabled() {
  try {
    const override = window?.localStorage?.getItem(CONNECT_FLAG_KEY)
    if (override === '1') return true
    if (override === '0') return false
  } catch (e) {}
  return process.env.VUE_APP_CONNECT === '1'
}
